const NGROK_SKIP_WARNING_HEADER = 'ngrok-skip-browser-warning';

function isNgrokFreeUrl(input: RequestInfo | URL) {
  const url = typeof input === 'string'
    ? input
    : input instanceof URL
      ? input.href
      : input.url;

  try {
    return new URL(url, window.location.origin).hostname.endsWith('.ngrok-free.app');
  } catch {
    return false;
  }
}

function withNgrokHeader(init?: RequestInit) {
  const headers = new Headers(init?.headers);
  headers.set(NGROK_SKIP_WARNING_HEADER, 'true');

  return {
    ...init,
    headers,
  };
}

export function installNgrokFetchPatch() {
  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    if (isNgrokFreeUrl(input)) {
      return nativeFetch(input, withNgrokHeader(init));
    }

    return nativeFetch(input, init);
  };
}
